import request from "src/utils/request";
const baseURL = '/tenant-api'//租户后台接口
// 获取用户详细信息
export function getInfo() {
  return request({
    baseURL,
    url: '/system/user/getInfo',
    method: 'get'
  })
}
// 退出方法
export function logout () {
  return request({
    baseURL,
    url: '/auth/logout',
    method: 'delete'
  })
}